const ClockIcon1 = () => {
  return (
    <svg
      width="19"
      height="21"
      viewBox="0 0 19 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0698 0.0100098H6.06982V2.01001H12.0698V0.0100098ZM8.06982 13.01H10.0698V7.01001H8.06982V13.01ZM16.0998 6.39001L17.5198 4.97001C17.0898 4.46001 16.6198 3.98001 16.1098 3.56001L14.6898 4.98001C13.1398 3.74001 11.1898 3.00001 9.06982 3.00001C4.09982 3.00001 0.0698242 7.03001 0.0698242 12C0.0698242 16.97 4.08982 21 9.06982 21C14.0498 21 18.0698 16.97 18.0698 12C18.0698 9.89001 17.3298 7.94001 16.0998 6.39001ZM9.06982 19.01C5.19982 19.01 2.06982 15.88 2.06982 12.01C2.06982 8.14001 5.19982 5.01001 9.06982 5.01001C12.9398 5.01001 16.0698 8.14001 16.0698 12.01C16.0698 15.88 12.9398 19.01 9.06982 19.01Z"
        fill="#01B574"
      />
    </svg>
  );
};

export default ClockIcon1;
